/*
 * Author M. Atoar Rahman
 * Title: Center Stock In
 * Description: Page for Center Stock In
 * Date: 15/03/2022
 */

import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { CurrentStockEntryProvider } from '../masterSetup/currentStockEntry/ContextAPI';
import Index from '../masterSetup/currentStockEntry/Index';
import { ManufacturerProvider } from '../masterSetup/manufacturer/ContextAPI';
import { SupplierProvider } from '../masterSetup/supplier/ContextAPI';
import PermissionDenied from './PermissionDenied';

export default function CurrentStockEntry() {
    // Only Super Admin can access Current Stock Entry
    const { auth } = useAuth();

    const normalizeRoles = (roles) => {
        if (!roles) return [];
        if (Array.isArray(roles)) return roles;
        return [roles];
    };

    const roleList = normalizeRoles(
        auth?.roles ??
            auth?.user?.roles ??
            auth?.users?.roles ??
            auth?.role_info ??
            auth?.user?.role_info ??
            auth?.users?.role_info
    );

    const isSuperAdmin = roleList.some((role) => {
        const roleId = Number(role?.role_id ?? role?.id ?? role ?? 0);
        const roleName = String(role?.role_name ?? role?.name ?? role ?? '').trim().toLowerCase();

        return (
            roleId === 2 ||
            roleName.includes('super admin') ||
            roleName.includes('administrator') ||
            roleName.includes('admin')
        );
    });

    const routePermission = auth?.route_permissions?.['current-stock-entry'];
    const hasRouteAccess =
        !!routePermission &&
        (routePermission.view !== false ||
            routePermission.read !== false ||
            routePermission.add === true ||
            routePermission.edit === true ||
            routePermission.delete === true ||
            routePermission.change === true ||
            routePermission.permission === true);

    if (!isSuperAdmin && !hasRouteAccess)
        return (
            <PermissionDenied
                message="Only Super Admin can use this page. Please use the '/center-stock-in' URL for stock entry."
                link={{ to: '/center-stock-in', text: 'Go to Center Stock In' }}
            />
        );

    return (
        <CurrentStockEntryProvider>
            <ManufacturerProvider>
                <SupplierProvider>
                    <Index />
                </SupplierProvider>
            </ManufacturerProvider>
        </CurrentStockEntryProvider>
    );
}
